/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "cognito",
            "endpoint": "https://ya53mpikj2.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        },
        {
            "name": "jsreport",
            "endpoint": "https://7ktq9753h6.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        },
        {
            "name": "photos",
            "endpoint": "https://06hyv09ibk.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        },
        {
            "name": "weather",
            "endpoint": "https://njh1mmrhpa.execute-api.us-east-1.amazonaws.com/production",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://77nvtubzvvglfe2e6kwlxd2g5y.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-7zpa555corfqhenzhrn6l5gphy",
    "aws_cognito_identity_pool_id": "us-east-1:7c72721c-5d01-42db-a654-1bb6292becf0",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_6cxqKGHi8",
    "aws_user_pools_web_client_id": "3p18kv4o51q0rat640odkl77k1",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "crisp-photostore130233-production",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
